import { types, flow } from 'mobx-state-tree'
import * as ChatService from "~/services/chat"

const SBAgent = types
  .model('SBAgent', {
    // The unique ID of the agent
    id: types.maybeNull(types.integer),
    // The nickname of the agent - maximum length is limited to 100 characters
    displayName: types.maybeNull(types.string),
    // The unique ID of a Desk project where the agent belongs
    project: types.maybeNull(types.integer),
    // The unique user ID of the agent
    user: types.maybeNull(types.string),
    // The unique ID of the agent used in Sendbird Chat platform (Limit 100 characters)
    sendbirdId: types.maybeNull(types.string),
    // Indicates whether the agent is admin or not
    // Valid values are ADMIN and AGENT
    role: types.maybeNull(types.string),
    // The date and time when the agent was created, in ISO 8601 format
    createdAt: types.maybeNull(types.string),
    // Indicates whether the agents' account is activated
    // Valid values are ACTIVE, INACTIVE, PAUSED. PAUSED is only applicable to virtual agents, also known as bots.
    status: types.maybeNull(types.string),
    // The connection status of the agent
    // Valid values are ONLINE, OFFLINE, and AWAY.
    connection: types.maybeNull(types.string),
    // The email address of the agent
    email: types.maybeNull(types.string),
    // The profile image URL of the agent
    photoThumbnailUrl: types.maybeNull(types.string),
    // The date and time of the agent's latest connection status update, in ISO 8601 format
    connectionUpdatedAt: types.maybeNull(types.string),
    // The level of the agent
    // Valid values are INTERMEDIATE and EXPERT. (Default: INTERMEDIATE)
    tier: types.maybeNull(types.string),
  })
  .views(self => ({
    // get testGetter() {
    //   return "Some calculated agent value"
    // },
  }))
  .actions(self => ({
    // Retrieves a list of agents registered in the application:
    listAgents: flow(function* listAgentsGen() {
      yield ChatService.listAgents()
    }),
    // Retrieves information on a specific agent:
    viewAgent: flow(function* viewAgentGen(agentID) {
      yield ChatService.viewAgent(agentID)
    }),
    // Updates the connection status of a specific agent:
    updateAgentConnectionStatus: flow(function* updateAgentConnectionStatusGen(agentID) {
      yield ChatService.updateAgentConnectionStatus(agentID)
    }),
    // Cancels assignment of tickets from a specific agent:
    cancelAssignments: flow(function* cancelAssignmentsGen(agentID) {
      yield ChatService.cancelAssignments(agentID)
    }),
    // Retrieves a list of a specific agent's connection logs:
    getConnectionLogsForAgent: flow(function* getConnectionLogsForAgentGen(agentID) {
      yield ChatService.getConnectionLogsForAgent(agentID)
    }),
    // Retrieves the number of an agent’s assigned tickets:
    getAssignedTicketsForAgent: flow(function* getAssignedTicketsForAgentGen(agentID) {
      yield ChatService.getAssignedTicketsForAgent(agentID)
    }),
    // Retrieves the number of an agent’s closed tickets:
    getClosedTicketsForAgent: flow(function* getClosedTicketsForAgentGen(agentID) {
      yield ChatService.getClosedTicketsForAgent(agentID)
    }),
  }))

export default SBAgent
